// Safely coerce an axios error's `response.data.detail` into a single
// readable string, no matter which shape FastAPI returned:
//
//   • plain 4xx/5xx  → `detail` is a string      (returned as-is)
//   • 422 validation → `detail` is an ARRAY of {loc, msg, type} objects
//                      (flattened to "field: msg; field: msg")
//   • pydantic-nested → `detail` is an OBJECT ({msg,...})
//
// Passing the raw array/object into toast.error() (or rendering it in
// JSX) yields "[object Object]" or a React "objects are not valid as a
// React child" crash. Every catch handler that surfaces backend errors
// to the user should route through this helper.
export function errText(e, fallback = 'Failed') {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    return d.map((it) => {
      if (typeof it === 'string') return it;
      const loc = Array.isArray(it?.loc)
        ? it.loc.filter((p) => p !== 'body').join('.')
        : '';
      const msg = it?.msg || JSON.stringify(it);
      return loc ? `${loc}: ${msg}` : msg;
    }).join('; ');
  }
  if (typeof d === 'object') {
    return d.msg || d.message || JSON.stringify(d);
  }
  return String(d);
}

export default errText;
